import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { CompanyListComponent } from './components/company/company-list/company-list.component';
import { CompanyDetailComponent } from './components/company/company-detail/company-detail.component';
import { JobListComponent } from './components/job/job-list/job-list.component';
import { PostJobAnalysisComponent } from './components/job/post-job-analysis/post-job-analysis.component';
import { UserListComponent } from './components/user/user-list/user-list.component';
import { UserDetailComponent } from './components/user/user-detail/user-detail.component';
import { DeviceListComponent } from './components/device/device-list/device-list.component';
import { DeviceDetailComponent } from './components/device/device-detail/device-detail.component';
import { DeviceDiagnosticsComponent } from './components/device/device-diagnostics/device-diagnostics.component';
//import { WorkbookComponent } from './components/workbook/workbook.component';
import { OfflineWorkbookComponent } from './components/offlineWorkbook/offlineWorkbook.component';
import { OfflineWorkbookDetailComponent } from './components/offlineWorkbook/offlineWorkbook-detail/offlineWorkbook-detail.component';
import { CanEditGuard } from './guards/canEdit.guard';
import { GlobalAdminGuard } from './guards/global-admin.guard';
import { RequestComponent } from './components/request/request.component';
import { FeatureGuard } from './guards/feature.guard';
import { VendorJobComponent } from './components/job/vendor-job/vendor-job.component';
import { ConsumerJobComponent } from './components/job/consumer-job/consumer-job.component';
import { VendorConsumerJobsComponent } from './components/job/vendor-consumer-jobs/vendor-consumer-jobs.component';
import { JobsRedirectComponent } from './components/jobs-redirect/jobs-redirect.component';
import { JobLinkerAdminComponent } from './components/job-linker-admin/job-linker-admin.component';
import { MsalGuard } from '@azure/msal-angular';
import { GlobalFilesContainerComponent } from './components/files/global-files-container/global-files-container.component';
import { CompanyFilesContainerComponent } from './components/files/company-files-container/company-files-container.component';
import { TicketListComponent } from './components/ticket-system/ticket-list/ticket-list.component';
import { ApiHelpComponent } from './components/api-help/api-help.component';
import { CsvimportComponent } from './components/job/csvimport/csvimport.component';
import { UserwithcompanyComponent } from './components/userwithcompany/userwithcompany.component';
import { HasCompanyGuard } from './guards/hascompany.guard';
import { JobIntegrationsComponent } from './components/job-integrations/job-integrations.component';
import { WorkbookComponent } from './components/workbook/workbook.component';
import { ShiftSummaryListComponent } from './components/shift-summary/shift-summary-list/shift-summary-list.component';
import { ShiftSummaryCreateComponent } from './components/shift-summary/shift-summary-create/shift-summary-create.component';
import { ShiftSummaryViewComponent } from './components/shift-summary/shift-summary-view/shift-summary-view.component';
import { ShiftSummaryFieldSourcesComponent } from './components/shift-summary/shift-summary-field-sources/shift-summary-field-sources.component';

export const routes: Routes = [
   
    
    {
        // Needed for hash routing
        path: 'error',
        component: JobsRedirectComponent
      },
      {
        // Needed for hash routing
        path: 'state',
        component: JobsRedirectComponent
      },
      {
        // Needed for hash routing
        path: 'code',
        component: JobsRedirectComponent
      },
    { path: '', component: JobsRedirectComponent, canActivate: [MsalGuard] },
    { path: 'companies', component: CompanyListComponent, canActivate: [MsalGuard, CanEditGuard] },
    { path: 'company/:id', component: CompanyDetailComponent, canActivate: [MsalGuard, CanEditGuard] },
    { path: 'jobs', component: JobListComponent, canActivate: [MsalGuard] },
    { path: 'Jobs2', redirectTo: 'jobs2' },
    { path: 'jobs2', component: VendorConsumerJobsComponent, canActivate: [MsalGuard, HasCompanyGuard] },
    //{ path: 'job/:id', component: JobDetailComponent, canActivate: [MsalGuard] },
    { path: 'jobs/postjobanalysis', component: PostJobAnalysisComponent, canActivate: [MsalGuard]},
    { path: 'users', component: UserListComponent, canActivate: [MsalGuard, CanEditGuard] },
    { path: 'user/:id', component: UserDetailComponent, canActivate: [MsalGuard] },
    { path: 'devices', component: DeviceListComponent, canActivate: [MsalGuard, CanEditGuard] },
    { path: 'device/:id', component: DeviceDetailComponent, canActivate: [MsalGuard, CanEditGuard] },
  { path: 'device-diagnostics', component: DeviceDiagnosticsComponent, canActivate: [MsalGuard, GlobalAdminGuard] },
    { path: 'workbook/:id', component: WorkbookComponent, canActivate: [MsalGuard] },
    { path: 'workbook2/:id', component: OfflineWorkbookComponent, canActivate: [MsalGuard] },
    { path: 'workbook2/:id/:consumerJobId', component: OfflineWorkbookComponent, canActivate: [MsalGuard] },
    { path: 'workbook2/detail/:companyId/:jobId/:id', component: OfflineWorkbookDetailComponent, canActivate: [MsalGuard] },
    { path: 'requests', component: RequestComponent, canActivate: [MsalGuard, FeatureGuard] },
    { path: 'requests/:requestType', component: RequestComponent, canActivate: [MsalGuard, FeatureGuard] },
    { path: 'job/:id', redirectTo: 'vendorjob/:id', pathMatch: 'full' },
    { path: 'vendorjob/:id', component: VendorJobComponent, canActivate: [MsalGuard] },
    { path: 'consumerjob/:id', component: ConsumerJobComponent, canActivate: [MsalGuard] },
    { path: 'joblinkers', component: JobLinkerAdminComponent, canActivate: [MsalGuard] },
    { path: 'home', component: JobsRedirectComponent, canActivate: [MsalGuard] },
    { path: 'files', component: GlobalFilesContainerComponent, canActivate: [MsalGuard] },
  { path: 'company-files/:companyId', component: CompanyFilesContainerComponent, canActivate: [MsalGuard] },
    { path: 'tickets', component: TicketListComponent, canActivate: [MsalGuard] },
    { path: 'api-help', component: ApiHelpComponent, canActivate: [MsalGuard] },
    { path: 'csvimport/:jobId', component: CsvimportComponent, canActivate: [MsalGuard] },
    { path: 'nocompany', component: UserwithcompanyComponent, canActivate: [MsalGuard] },
    { path: 'job-integrations', component: JobIntegrationsComponent, canActivate: [MsalGuard] },
    { path: 'shift-summary-field-sources', component: ShiftSummaryFieldSourcesComponent, canActivate: [MsalGuard] },
    { path: 'vendorjob/:id/shiftsummaries', component: ShiftSummaryListComponent, canActivate: [MsalGuard] },
    { path: 'vendorjob/:id/shiftsummaries/new', component: ShiftSummaryCreateComponent, canActivate: [MsalGuard] },
    { path: 'vendorjob/:id/shiftsummaries/:shiftSummaryId/view', component: ShiftSummaryViewComponent, canActivate: [MsalGuard] },
    { path: 'vendorjob/:id/shiftsummaries/:shiftSummaryId', component: ShiftSummaryCreateComponent, canActivate: [MsalGuard] },
];

export const AppRoutes: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
    useHash: false
  } );
